module.exports = __webpack_public_path__ + "static/media/what-nodejs-can-do.ac521e0c.md";